import React, { Component } from 'react';
// import * as $ from 'jquery';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter, Link, Redirect } from 'react-router-dom';
import Header from '../../../components/Header';
import GoBackButton from '../../../components/GoBackButton';
import Dialog from '../../../components/Dialog';
import Input from '../../../components/Input';

let cancelToken;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

const periodos = [
    { name: '3 Meses', multi_by: 3 },
    { name: '6 Meses', multi_by: 6 },
    { name: '12 Meses', multi_by: 12 }
]
class PaymentDomicilioContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            center: null,
            email: "",
            name: "",
            lastname: "",
            phone: "",
            centro_id: this.props.match.params.domicilioid,
            duracion_id: 1,
            error: null,
            showModalCenterUnavailable: false,
            fieldsValid: {}
        };
    }

    componentDidMount() {
        const data = window.sessionStorage.getItem('paymentData');
        if (data) this.setState(JSON.parse(data));
        cancelToken = axios.CancelToken.source();
        // Verifica si el centro seleccionado existe

        this.getDomicilio({ token_id: this.props.getTokenId(), domicilio_id: this.state.centro_id })
            .then((center) => {
                this.setState({ center });
            })
    }

    componentWillUnmount() {
        const keys = ['email', 'name', 'lastname', 'phone', 'duracion_id', 'duracion_str', 'precio'];
        // Se piensa eliminar duracion_str y precio ya que son datos que se pueden calcular con la duracion_id y el backend

        const data = keys.reduce((acc, key) => {
            acc[key] = this.state[key];
            return acc;
        }, {});

        window.sessionStorage.setItem('paymentData', JSON.stringify(data));
        cancelToken.cancel('Component will unmount.');
    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    getDomicilio = (params) => {
        return new Promise((resolve, reject) => {
            this.props.post(
                "/getDomicilio",
                params,
                (response) => resolve(response),
                (error) => reject(error),
                cancelToken
            );
        })
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const period = periodos[this.state.duracion_id];
        const precio = this.state.center.precio * period.multi_by;
        const duracion_str = period.name;
        if (!period) return alert('Seleccione un periodo de tiempo');

        const isValid = Object.values(this.state.fieldsValid).every((value) => value);
        if (!isValid) return alert('Por favor, llene todos los campos correctamente');

        this.props.history.replace({
            pathname: "payment/" + this.state.centro_id + "/" + this.state.duracion_id,
            state: {
                email: this.state.email,
                name: this.state.name,
                lastname: this.state.lastname,
                phone: this.state.phone,
                duracion_id: this.state.duracion_id,
                duracion_str,
                precio
            }
        })
    }

    handleError = () => {
        console.log(this.state.error)
        this.props.history.replace(`${URI_VENTA_EN_LINEA}/domicilio_comercial`);
    }

    render() {
        if (this.state.error) {
            return this.handleError();
        }

        const { t } = this.props;
        const center = this.state.center || {
            id: null,
            name: '...',
            precio: 0
        };
        return (
            <form className="content-resvations" onSubmit={this.handleSubmit}>
                <Header>
                    <h2>
                        <Trans i18nKey='venta_linea.index.domicilio.title'>
                            0 <br /> 2
                        </Trans>
                    </h2>
                </Header>
                <div className="container-domiciolio">
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="container-forms flex-horizontal">
                            <h2 className="page-header">
                                <Trans>venta_linea.payment.personal_info</Trans>
                            </h2>
                            <div className="form-group">
                                <div className="input-group input-lg-xl">
                                    <div className="form-group">
                                        <select
                                            disabled={true}
                                            className="form-control input-lg"
                                            id="city-select"
                                            value={this.state.centro_id}>
                                            <option className="opcion-select">{center.name}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="input-group-btn input-group-btn-movil">
                                    <Link to={`${URI_VENTA_EN_LINEA}/domicilio_comercial`}>
                                        <span className="return-store">
                                            <Trans>venta_linea.payment.change_center</Trans>
                                        </span>
                                    </Link>
                                </div>
                                <br></br>
                                <div className="input-group-btn btn-group input-group-btn-movil">
                                    <div className="grid-3">
                                        {
                                            periodos.map((periodo, index) => (
                                                <button
                                                    key={periodo.name}
                                                    type="button"
                                                    onClick={() => this.setState({ duracion_id: index })}
                                                    className={this.state.duracion_id === index ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                                    <p>{periodo.name}</p>
                                                    <p className="btn_store_text">{
                                                        (center.precio * periodo.multi_by).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 })
                                                    } MXN<br></br>+ IVA</p>
                                                </button>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms">
                            <div className="forms">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleEmailChange}
                                            placeholder={t('dashboard.room_payment.holder_email')}
                                            required
                                            type="email"
                                            name="email"
                                            onValidate={this.handleValidate}
                                            value={this.state.email} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleNameChange}
                                            placeholder={t('dashboard.room_payment.holder_name')}
                                            required
                                            type="text"
                                            name="name"
                                            onValidate={this.handleValidate}
                                            value={this.state.name} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleLastnameChange}
                                            placeholder={t('dashboard.room_payment.holder_lastname')}
                                            required
                                            type="text"
                                            name="lastname"
                                            onValidate={this.handleValidate}
                                            value={this.state.lastname} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handlePhoneChange}
                                            placeholder={t('dashboard.room_payment.holder_phone')}
                                            required
                                            type="tel"
                                            pattern="[0-9]{10}"
                                            name="phone"
                                            onValidate={this.handleValidate}
                                            value={this.state.phone} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <span className="return-store">
                                        * <Trans>venta_linea.payment.accept_contact</Trans>
                                    </span>
                                </div>
                                <section className="row">
                                    <GoBackButton
                                        isButtonForm
                                        isPayment
                                    />
                                    <button className="continua_button btn btn-primary col-md-6">
                                        <Trans>dashboard.room_payment.btn_continue</Trans>
                                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showModalCenterUnavailable &&
                    <Dialog
                        title={t('venta_linea.modal.title_center_unavailable')}
                        handleDismiss={() => this.props.history.replace(`${URI_VENTA_EN_LINEA}`)}
                    >
                        {t('venta_linea.modal.description_center_unavailable')}
                    </Dialog>
                }
            </form>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(PaymentDomicilioContainer);



// WEBPACK FOOTER //
// ./src/store/Domicilio/Payment/PaymentDomicilioContainer.js